// Generated by purs version 0.11.7
"use strict";
var $foreign = require("./foreign");
var Control_Applicative = require("../Control.Applicative");
var Control_Apply = require("../Control.Apply");
var Control_Bind = require("../Control.Bind");
var Control_Monad_Eff = require("../Control.Monad.Eff");
var Control_Semigroupoid = require("../Control.Semigroupoid");
var DOM_Event_EventTarget = require("../DOM.Event.EventTarget");
var DOM_HTML_HTMLImageElement = require("../DOM.HTML.HTMLImageElement");
var Data_Eq = require("../Data.Eq");
var Data_Foreign = require("../Data.Foreign");
var Data_Function = require("../Data.Function");
var Data_Generic = require("../Data.Generic");
var Data_Lens = require("../Data.Lens");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget");
var Data_Lens_Lens = require("../Data.Lens.Lens");
var Data_Lens_Record = require("../Data.Lens.Record");
var Data_Maybe = require("../Data.Maybe");
var Data_Newtype = require("../Data.Newtype");
var Data_Ord = require("../Data.Ord");
var Data_Symbol = require("../Data.Symbol");
var Data_Tuple = require("../Data.Tuple");
var Data_Unit = require("../Data.Unit");
var FRP = require("../FRP");
var FRP_Behavior = require("../FRP.Behavior");
var FRP_Event = require("../FRP.Event");
var Halogen_VDom_DOM_Prop = require("../Halogen.VDom.DOM.Prop");
var Prelude = require("../Prelude");
var PrestoDOM_Types = require("../PrestoDOM.Types");
var PrestoDOM_Types_DomAttributes = require("../PrestoDOM.Types.DomAttributes");
var Unsafe_Coerce = require("../Unsafe.Coerce");
var PropName = function (x) {
    return x;
};
var Dynamic = (function () {
    function Dynamic(value0) {
        this.value0 = value0;
    };
    Dynamic.create = function (value0) {
        return new Dynamic(value0);
    };
    return Dynamic;
})();
var IsProp = function (toPropValue) {
    this.toPropValue = toPropValue;
};
var MkDynamic = function (mkDyn) {
    this.mkDyn = mkDyn;
};
var toPropValue = function (dict) {
    return dict.toPropValue;
};
var stringIsProp = new IsProp(Halogen_VDom_DOM_Prop.propFromString);
var ordPropName = Data_Ord.ordString;
var numberIsProp = new IsProp(Halogen_VDom_DOM_Prop.propFromNumber);
var newtypePropName = new Data_Newtype.Newtype(function (n) {
    return n;
}, PropName);
var mkDyn = function (dict) {
    return dict.mkDyn;
};
var lengthIsProp = new IsProp(function ($21) {
    return Halogen_VDom_DOM_Prop.propFromString(PrestoDOM_Types_DomAttributes.renderLength($21));
});
var intIsProp = new IsProp(Halogen_VDom_DOM_Prop.propFromInt);
var genericPropName = new Data_Generic.Generic(function (v) {
    if (v instanceof Data_Generic.SProd && (v.value0 === "PrestoDOM.Core.PropName" && v.value1.length === 1)) {
        return Control_Apply.apply(Data_Maybe.applyMaybe)(new Data_Maybe.Just(PropName))(Data_Generic.fromSpine(Data_Generic.genericString)(v["value1"][0](Data_Unit.unit)));
    };
    return Data_Maybe.Nothing.value;
}, function ($dollarq) {
    return new Data_Generic.SigProd("PrestoDOM.Core.PropName", [ {
        sigConstructor: "PrestoDOM.Core.PropName",
        sigValues: [ function ($dollarq1) {
            return Data_Generic.toSignature(Data_Generic.genericString)(Data_Generic.anyProxy);
        } ]
    } ]);
}, function (v) {
    return new Data_Generic.SProd("PrestoDOM.Core.PropName", [ function ($dollarq) {
        return Data_Generic.toSpine(Data_Generic.genericString)(v);
    } ]);
});
var genericMkDyn = function (defaultValue) {
    return function __do() {
        var v = FRP_Event.create();
        return new Dynamic({
            beh: FRP_Behavior.step(FRP_Event.eventIsEvent)(defaultValue)(v.event),
            event: v.event,
            push: v.push
        });
    };
};
var strDyn = new MkDynamic(genericMkDyn);
var eqPropName = Data_Eq.eqString;
var booleanIsProp = new IsProp(Halogen_VDom_DOM_Prop.propFromBoolean);
var boolDyn = new MkDynamic(genericMkDyn);
var _Dynamic = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        return v.value0;
    })(function (v) {
        return Dynamic.create;
    })(dictStrong);
};
var beh = function ($22) {
    return _Dynamic(Data_Lens_Internal_Forget.strongForget)(Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "beh";
    }))()()(Data_Symbol.SProxy.value)(Data_Lens_Internal_Forget.strongForget)($22));
};
var ev = function ($23) {
    return _Dynamic(Data_Lens_Internal_Forget.strongForget)(Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "event";
    }))()()(Data_Symbol.SProxy.value)(Data_Lens_Internal_Forget.strongForget)($23));
};
module.exports = {
    IsProp: IsProp,
    toPropValue: toPropValue,
    PropName: PropName,
    Dynamic: Dynamic,
    MkDynamic: MkDynamic,
    mkDyn: mkDyn,
    beh: beh,
    ev: ev,
    newtypePropName: newtypePropName,
    eqPropName: eqPropName,
    ordPropName: ordPropName,
    genericPropName: genericPropName,
    stringIsProp: stringIsProp,
    intIsProp: intIsProp,
    numberIsProp: numberIsProp,
    booleanIsProp: booleanIsProp,
    lengthIsProp: lengthIsProp,
    strDyn: strDyn,
    boolDyn: boolDyn,
    click: $foreign.click
};



//////////////////
// WEBPACK FOOTER
// ./output/PrestoDOM.Core/index.js
// module id = 102
// module chunks = 0